<template>
	<svg width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 452.27">
		<g id="Layer_1" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
			<path :fill="color" d="M110.99,30.44c58.69,44.22,121.84,133.86,145.01,181.96,23.18-48.1,86.32-137.74,145.02-181.96,42.36-31.9,110.99-56.58,110.99,21.96,0,15.68-8.96,131.78-14.22,150.63-18.27,65.52-84.87,82.23-144.11,72.12,103.55,17.68,129.89,76.24,73,134.8-108.04,111.22-155.29-27.9-167.38-63.55-3.49-10.26-2.99-10.5-6.56,0-12.1,35.65-59.34,174.78-167.38,63.55-56.89-58.56-30.55-117.12,73-134.8-59.24,10.11-125.84-6.6-144.11-72.12C8.96,184.18,0,68.08,0,52.4,0-26.14,68.63-1.45,110.99,30.44Z" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'IconTwitter',
	props: {
		color: {
			type: String,
			default: '#4b4b4b'
		}
	}
}
</script>
